class BenefitItemsScroll {
  constructor() {
    this.items = document.querySelectorAll('.benefit-item');
    if (this.items.length === 0) return;
    
    this.init();
  }

  init() {
    const options = {
      root: null,
      rootMargin: '-40% 0px -40% 0px', // Trigger when item is near center (within middle 20% of viewport)
      threshold: 0
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('benefit-item--active');
        }
        // Keep opacity at 1 once activated - don't remove the class
      });
    }, options);

    this.items.forEach(item => {
      this.observer.observe(item);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BenefitItemsScroll();
  });
} else {
  new BenefitItemsScroll();
}
